import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const INITIAL_STATE = {
  isViewingBatch: false,
  selectedBatch: null,
};

const useBulkUploadsStore = create(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      openBatch: ({ id, batchId }) => set({ isViewingBatch: true, selectedBatch: { id, batchId } }),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: "bulk-uploads-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isViewingBatch: state.isViewingBatch,
        selectedBatch: state.selectedBatch,
      }),
    },
  ),
);

export default useBulkUploadsStore;
